module.exports = __webpack_public_path__ + "img/drh5_share_en.a7301e9a.png";